import { faUser } from "@fortawesome/free-solid-svg-icons";
import { reduce, isPositiveNumber } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import getQAStore from "../../../../stores/qa";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const ChangeEmailSubscriptionForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = reduce(() => getQAStore().subscriptionUserID.get(), -1);
  const allowToChangeDate = isPositiveNumber(userID);

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        icon={faUser}
        type={"number"}
        label={i18n.get("USER_ID")}
        placeHolder={i18n.get("USER_ID")}
        onChoose={(value: number) => {
          getQAStore().setSubscriptionUserID(value);
        }}
        onBlur={() => {}}
        value={userID}
        style={{}}
        onEnter={() => {}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={620}
        height={130}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          size="LARGE"
          isEnabled={allowToChangeDate}
          onClick={async () => await getQAStore().changeEmailSubscription(1)}
          type="APPROVE"
          text={"SUBSCRIBE"}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Button
          size="LARGE"
          isEnabled={allowToChangeDate}
          onClick={async () => await getQAStore().changeEmailSubscription(0)}
          type="REJECT"
          text={"UNSUBSCRIBE"}
        />
      </ET3Div>
    </React.Fragment>
  );
});

export default ChangeEmailSubscriptionForm;
